import {
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updatePassword as firebaseUpdatePassword,
} from 'firebase/auth';
import { collection, doc, getDoc } from 'firebase/firestore';
import { auth, firestore } from '../helpers/firebase';

export const createUserWithEmail = (email, password) => createUserWithEmailAndPassword(auth, email, password);

export const userLogout = () => signOut(auth).then(() => { window.location.href = '/'; });

export const updateUserProfile = (newProfile) => {
  const user = auth.currentUser;
  return user.updateProfile(newProfile);
};

export const userRole = async (userId) => {
  const returnUserRole = await getDoc(doc(firestore, 'roles', userId))
    .then(snapshot => ({ role: snapshot.data().role }))
    .catch(() => ({ role: 'guest' }));
  return returnUserRole;
};

export const forgotPassword = async email => sendPasswordResetEmail(auth, email)
  .then(() => ({ status: 'success', message: 'Email sent successfully' }))
  .catch(error => ({ status: 'error', message: error }));

export const updatePassword = async newPassword => firebaseUpdatePassword(auth.currentUser, newPassword)
  .then(() => ({ status: 'success', message: 'Password updated successfully' }))
  .catch(error => ({ status: 'error', message: error.message }));
